import {SheetOption} from '~/SignUpSheets/components/Header/components/SheetOptions/components/SheetOption/SheetOption';
import {useSheetOptions} from '~/SignUpSheets/components/Header/components/SheetOptions/context/SheetOptionsContext';
import {EyeIcon} from '~library/svg/EyeIcon';

export const ViewSheet = () => {
  const {closeOptions} = useSheetOptions();

  return <SheetOption title="View sheet" icon={<EyeIcon ratio={0.5} />} onClick={closeOptions} />;
};
